import {IUrlParams} from '../interface'

export const initialUrlParams: IUrlParams = {}